export default {"src":"https://images-cdn.curipod.com/d-bacd9c5f/_next/static/media/loaderstars.62e39e18.svg","height":669,"width":679};